// Mock data & seeded state for Akta Wealth Financial MRI (frontend-only phase v2)
// Roles: admin > sales_head > rm

export const AKTA_DOMAIN = 'aktawealth.com';

export const ROLES = {
  ADMIN: 'admin',
  SALES_HEAD: 'sales_head',
  RM: 'rm'
};

// All internal Akta Wealth users
export const USERS = [
  { id: 'u-admin', role: ROLES.ADMIN, name: 'Vikram Shah', email: 'admin@aktawealth.com', title: 'Founder & Compliance Officer' },
  { id: 'sh-001', role: ROLES.SALES_HEAD, name: 'Rohan Kapadia', email: 'rohan.sh@aktawealth.com', title: 'Retail Sales Head — Gujarat South', rm_ids: ['rm-001', 'rm-002'] },
  { id: 'sh-002', role: ROLES.SALES_HEAD, name: 'Divya Trivedi', email: 'divya.sh@aktawealth.com', title: 'Retail Sales Head — Gujarat North', rm_ids: ['rm-003'] },
  { id: 'rm-001', role: ROLES.RM, name: 'Akta Shah', email: 'akta@aktawealth.com', euin: 'E123456', title: 'Relationship Manager', arn: 'ARN-47282', sales_head_id: 'sh-001' },
  { id: 'rm-002', role: ROLES.RM, name: 'Nikita Joshi', email: 'nikita@aktawealth.com', euin: 'E234567', title: 'Relationship Manager', arn: 'ARN-47282', sales_head_id: 'sh-001' },
  { id: 'rm-003', role: ROLES.RM, name: 'Parth Bhavsar', email: 'parth@aktawealth.com', euin: 'E345678', title: 'Relationship Manager', arn: 'ARN-47282', sales_head_id: 'sh-002' }
];

export const findUserByEmail = (email) => {
  if (!email) return null;
  const e = email.trim().toLowerCase();
  return USERS.find((u) => u.email.toLowerCase() === e) || null;
};

export const seedClients = [
  {
    id: 'c-001', rm_id: 'rm-001',
    name: 'Ramesh & Priya Shah', phone: '+91 98250 12345', email: 'ramesh.shah@example.com', city: 'Surat',
    pan_last4: '4321', kyc_status: 'verified', created_at: '2024-08-14', updated_at: '2025-06-20'
  },
  {
    id: 'c-002', rm_id: 'rm-001',
    name: 'Meera Patel', phone: '+91 90999 45678', email: 'meera.p@example.com', city: 'Vadodara',
    pan_last4: '9910', kyc_status: 'verified', created_at: '2025-01-06', updated_at: '2025-07-05'
  },
  {
    id: 'c-003', rm_id: 'rm-002',
    name: 'Nikhil Desai', phone: '+91 98980 67890', email: 'nikhil.d@example.com', city: 'Ahmedabad',
    pan_last4: '2288', kyc_status: 'pending', created_at: '2025-03-22', updated_at: '2025-07-18'
  },
  {
    id: 'c-004', rm_id: 'rm-003',
    name: 'Ravi & Sunita Mehta', phone: '+91 97250 33221', email: 'ravi.mehta@example.com', city: 'Surat',
    pan_last4: '7788', kyc_status: 'verified', created_at: '2023-11-02', updated_at: '2025-05-14'
  },
  {
    id: 'c-005', rm_id: 'rm-002',
    name: 'Kavita Iyer', phone: '+91 99988 11234', email: 'kavita.iyer@example.com', city: 'Rajkot',
    pan_last4: '5566', kyc_status: 'verified', created_at: '2025-02-11', updated_at: '2025-07-01'
  }
];

export const seedSessions = [
  {
    id: 's-001', client_id: 'c-001', rm_id: 'rm-001',
    session_date: '2025-06-20', status: 'completed',
    age: 41, retire_age: 60, dependents: '2', city: 'Surat', regime: 'Old',
    mf_value: 1850000, equity_value: 320000, fd_value: 850000, realestate_value: 5200000, total_loans: 3770000,
    monthly_income: 185000, monthly_expense: 80000, monthly_emi: 35000, monthly_sip: 20000,
    risk_q1: 'wait', risk_q2: 'wealth', risk_q3: '7plus', risk_q4: '30-60',
    goals: [
      { id: 'g1', type: "Child's Education", amount: 2500000, years: 8, priority: 'Primary' },
      { id: 'g2', type: "Child's Marriage", amount: 1500000, years: 14, priority: 'Secondary' },
      { id: 'g3', type: 'Home Renovation', amount: 800000, years: 3, priority: 'Secondary' },
      { id: 'g4', type: 'Retirement Corpus', amount: 24000000, years: 19, priority: 'Long-term' }
    ],
    life_cover: 500000, health_cover: 500000, has_term: false, has_critical: false,
    monthly_retire_need: 80000, ppf_nps_epf: 650000, other_retire_sav: 0,
    tax_regime: 'Old', sec_80c: 109000, sec_80d: 18000, capital_gains: 'no',
    liquid_savings: 185000, equity_pct: '40-60', debt_pct: '20-40', last_rebalance: '1-2y',
    rm_notes: 'Client keen on child education corpus. Term insurance urgent.',
    next_action: 'Term plan quote, ELSS SIP setup',
    follow_up_date: '2025-08-15',
    conversation_log: [
      { ts: '2025-06-20T10:05:00', author: 'Akta Shah', text: 'Opened session. Client family joined the meeting.' },
      { ts: '2025-06-20T10:22:00', author: 'Akta Shah', text: 'Priya raised concern about child\u2019s education inflation. Explained SIP + step-up mechanics.' },
      { ts: '2025-06-20T10:41:00', author: 'Akta Shah', text: 'Ramesh agreed to explore a pure term plan of \u20b91 Cr; awaiting HR insurance documentation.' },
      { ts: '2025-06-20T11:03:00', author: 'Akta Shah', text: 'Closed session. Next follow-up scheduled 15 Aug 2025.' }
    ],
    signed_report: null
  },
  {
    id: 's-002', client_id: 'c-001', rm_id: 'rm-001',
    session_date: '2025-03-15', status: 'completed',
    age: 41, retire_age: 60, dependents: '2', city: 'Surat', regime: 'Old',
    mf_value: 1650000, equity_value: 290000, fd_value: 820000, realestate_value: 5200000, total_loans: 3820000,
    monthly_income: 180000, monthly_expense: 82000, monthly_emi: 35000, monthly_sip: 15000,
    risk_q1: 'wait', risk_q2: 'wealth', risk_q3: '7plus', risk_q4: '30-60',
    goals: [
      { id: 'g1', type: "Child's Education", amount: 2500000, years: 8, priority: 'Primary' },
      { id: 'g4', type: 'Retirement Corpus', amount: 24000000, years: 19, priority: 'Long-term' }
    ],
    life_cover: 500000, health_cover: 500000, has_term: false, has_critical: false,
    monthly_retire_need: 80000, ppf_nps_epf: 620000, other_retire_sav: 0,
    tax_regime: 'Old', sec_80c: 90000, sec_80d: 18000, capital_gains: 'no',
    liquid_savings: 150000, equity_pct: '40-60', debt_pct: '20-40', last_rebalance: '1-2y',
    rm_notes: 'Initial assessment. Awareness on emergency fund built.',
    next_action: 'Increase SIP to 20k', follow_up_date: '2025-06-15',
    conversation_log: [
      { ts: '2025-03-15T14:00:00', author: 'Akta Shah', text: 'First MRI session with Ramesh & Priya.' },
      { ts: '2025-03-15T14:35:00', author: 'Akta Shah', text: 'Emergency fund awareness discussed. Currently only 1.5 months buffer.' }
    ],
    signed_report: null
  },
  {
    id: 's-003', client_id: 'c-002', rm_id: 'rm-001',
    session_date: '2025-07-05', status: 'completed',
    age: 34, retire_age: 58, dependents: '1', city: 'Vadodara', regime: 'New',
    mf_value: 780000, equity_value: 120000, fd_value: 350000, realestate_value: 0, total_loans: 250000,
    monthly_income: 95000, monthly_expense: 45000, monthly_emi: 12000, monthly_sip: 18000,
    risk_q1: 'invest', risk_q2: 'wealth', risk_q3: '7plus', risk_q4: '60-80',
    goals: [
      { id: 'g1', type: 'Home Purchase', amount: 4000000, years: 5, priority: 'Primary' },
      { id: 'g2', type: 'Retirement Corpus', amount: 15000000, years: 24, priority: 'Long-term' }
    ],
    life_cover: 2500000, health_cover: 1000000, has_term: true, has_critical: false,
    monthly_retire_need: 60000, ppf_nps_epf: 220000, other_retire_sav: 0,
    tax_regime: 'New', sec_80c: 0, sec_80d: 0, capital_gains: 'ltcg',
    liquid_savings: 220000, equity_pct: '60plus', debt_pct: '0-20', last_rebalance: '<6m',
    rm_notes: 'Aggressive investor. Critical illness cover to be added.',
    next_action: 'Critical illness plan, portfolio rebalance review',
    follow_up_date: '2025-08-10',
    conversation_log: [
      { ts: '2025-07-05T11:00:00', author: 'Akta Shah', text: 'Session opened. Meera on Zoom, joined 5 min late.' },
      { ts: '2025-07-05T11:34:00', author: 'Akta Shah', text: 'Discussed critical illness rider on existing term plan. Agreed to review quote next visit.' }
    ],
    signed_report: null
  },
  {
    id: 's-004', client_id: 'c-003', rm_id: 'rm-002',
    session_date: '2025-07-18', status: 'completed',
    age: 29, retire_age: 60, dependents: '0', city: 'Ahmedabad', regime: 'New',
    mf_value: 320000, equity_value: 80000, fd_value: 180000, realestate_value: 0, total_loans: 0,
    monthly_income: 70000, monthly_expense: 30000, monthly_emi: 0, monthly_sip: 10000,
    risk_q1: 'invest', risk_q2: 'wealth', risk_q3: '7plus', risk_q4: '60-80',
    goals: [{ id: 'g1', type: 'Home Purchase', amount: 5000000, years: 7, priority: 'Primary' }],
    life_cover: 0, health_cover: 300000, has_term: false, has_critical: false,
    monthly_retire_need: 50000, ppf_nps_epf: 50000, other_retire_sav: 0,
    tax_regime: 'New', sec_80c: 0, sec_80d: 0, capital_gains: 'no',
    liquid_savings: 90000, equity_pct: '60plus', debt_pct: '0-20', last_rebalance: 'never',
    rm_notes: 'Young single professional. Priority: term plan + emergency fund.',
    next_action: 'Set up term plan, build 6-month emergency corpus',
    follow_up_date: '2025-08-20',
    conversation_log: [
      { ts: '2025-07-18T16:15:00', author: 'Nikita Joshi', text: 'First MRI for Nikhil. Explained term-plan importance.' }
    ],
    signed_report: null
  },
  {
    id: 's-005', client_id: 'c-004', rm_id: 'rm-003',
    session_date: '2025-05-14', status: 'completed',
    age: 52, retire_age: 62, dependents: '1', city: 'Surat', regime: 'Old',
    mf_value: 4200000, equity_value: 1500000, fd_value: 2200000, realestate_value: 12000000, total_loans: 1500000,
    monthly_income: 320000, monthly_expense: 140000, monthly_emi: 45000, monthly_sip: 50000,
    risk_q1: 'wait', risk_q2: 'income', risk_q3: '3-7', risk_q4: '30-60',
    goals: [
      { id: 'g1', type: 'Retirement Corpus', amount: 40000000, years: 10, priority: 'Primary' },
      { id: 'g2', type: "Child's Marriage", amount: 2000000, years: 6, priority: 'Secondary' }
    ],
    life_cover: 5000000, health_cover: 1500000, has_term: true, has_critical: true,
    monthly_retire_need: 150000, ppf_nps_epf: 3500000, other_retire_sav: 800000,
    tax_regime: 'Old', sec_80c: 150000, sec_80d: 25000, capital_gains: 'ltcg',
    liquid_savings: 950000, equity_pct: '40-60', debt_pct: '20-40', last_rebalance: '<6m',
    rm_notes: 'Retirement runway on track. Rebalance quarterly.',
    next_action: 'Q3 review, capital gains harvest', follow_up_date: '2025-09-14',
    conversation_log: [
      { ts: '2025-05-14T09:00:00', author: 'Parth Bhavsar', text: 'Annual review. All areas green.' }
    ],
    signed_report: null
  }
];

export const emptySession = () => ({
  id: `s-${Date.now()}`,
  client_id: null, rm_id: null,
  session_date: new Date().toISOString().slice(0, 10),
  status: 'draft',
  age: '', retire_age: '', dependents: '', city: '', regime: '',
  mf_value: '', equity_value: '', fd_value: '', realestate_value: '', total_loans: '',
  monthly_income: '', monthly_expense: '', monthly_emi: '', monthly_sip: '',
  risk_q1: '', risk_q2: '', risk_q3: '', risk_q4: '',
  goals: [],
  life_cover: '', health_cover: '', has_term: false, has_critical: false,
  monthly_retire_need: '', ppf_nps_epf: '', other_retire_sav: '',
  tax_regime: '', sec_80c: '', sec_80d: '', capital_gains: '',
  liquid_savings: '', equity_pct: '', debt_pct: '', last_rebalance: '',
  rm_notes: '', next_action: '', follow_up_date: '',
  conversation_log: [],
  signed_report: null
});

export const GOAL_TYPES = [
  "Child's Education", "Child's Marriage", 'Home Purchase', 'Home Renovation',
  'Vehicle', 'Business', 'Retirement Corpus', 'Travel', 'Emergency Corpus', 'Other'
];
